"use strict";

var _classCallCheck = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var parser = require('./g_parser');

var default_1 = /*#__PURE__*/function () {
  function default_1() {
    _classCallCheck(this, default_1);

    this.filenameToSource = new Map();
    this.sourceToAst = new Map();
  }

  _createClass(default_1, [{
    key: "getFileContents",
    value: function getFileContents(filename, loc, guardedReadFileSync) {
      var contents = this.filenameToSource.get(filename);

      if (contents !== undefined) {
        return contents;
      }

      var src = guardedReadFileSync(filename, loc);
      this.filenameToSource.set(filename, src);
      return src;
    }
  }, {
    key: "parse",
    value: function parse(filename, loc, guardedReadFileSync) {
      var source = this.getFileContents(filename, loc, guardedReadFileSync);

      if (source === undefined) {
        return undefined;
      }

      var cachedAst = this.sourceToAst.get(filename);

      if (cachedAst !== undefined) {
        return cachedAst;
      }

      var ast = parser.parse(source.toString(), {
        source: filename
      });
      this.sourceToAst.set(filename, ast);
      return ast;
    }
  }]);

  return default_1;
}();

exports.default = default_1;